import {LIMPAR_DADOS_VEXADO_BI} from '../types';

export default function limparDadosVexadoBI () {
  return {
    type: LIMPAR_DADOS_VEXADO_BI
  }
}
